import PlayFieldHeader from "../components/play-field-header";
import PlayFieldFooter from "../components/play-field-footer";
import PlayFieldRace from "../containers/play-field-race";
import pageable from "./higher-order/pageable";
import pure from "./higher-order/pure";
import React from "react";

function ticketPages({ myTickets, pageSize }) {
  return Math.ceil(myTickets.count() / pageSize);
}

export default pageable(ticketPages, pure(function PlayField({ bets, myTickets, nextPage, onMakeAlternatePick, onMakePick, page, pageSize, previousPage, raceEntrants, races, survivors, tickets, tokenTypes, tournament, users }) {
  var raceItems = races.map((race, i) => (
    <PlayFieldRace
      bets={bets}
      key={race.get("id")}
      myTickets={myTickets}
      number={i + 1}
      onMakeAlternatePick={onMakeAlternatePick}
      onMakePick={onMakePick}
      page={page}
      pageSize={pageSize}
      race={race}
      raceEntrants={raceEntrants}
      survivors={survivors}
      tickets={tickets}
      tournament={tournament}
      users={users} />
  ));
  return (
    <div>
      <PlayFieldHeader
        firstRace={races.first()}
        myTickets={myTickets}
        onNextPage={nextPage}
        onPreviousPage={previousPage}
        page={page}
        pageSize={pageSize}
        tokenTypes={tokenTypes}
        tournament={tournament} />

      <div className="game-table_wrapper">
        {raceItems}
      </div>

      <PlayFieldFooter
        myTickets={myTickets}
        page={page}
        pageSize={pageSize}
        tournament={tournament} />
    </div>
  );
}));
